import type { ItiUtils, UiTranslations } from 'intl-tel-input';

/** Cameroun — indicatif +237, sélectionnable par défaut à l'ouverture du formulaire. */
export const PHONE_INPUT_INITIAL_COUNTRY = 'cm';

export const PHONE_INPUT_DEFAULT_DIAL_CODE = '+237';

/** Cameroun en tête de liste ; tous les pays restent disponibles. */
export const PHONE_INPUT_COUNTRY_ORDER = ['cm'] as const;

export const PHONE_INPUT_FRENCH_TRANSLATIONS: UiTranslations = {
  selectedCountryAriaLabel:
    'Changer le pays du numéro, actuellement ${countryName} (${dialCode})',
  noCountrySelected: 'Sélectionner un pays',
  countryListAriaLabel: 'Liste des pays',
  searchPlaceholder: 'Rechercher un pays',
  clearSearchAriaLabel: 'Effacer la recherche',
  searchEmptyState: 'Aucun pays trouvé',
  searchSummaryAria(count: number): string {
    if (count === 0) {
      return 'Aucun pays trouvé';
    }
    if (count === 1) {
      return '1 pays trouvé';
    }
    return `${count} pays trouvés`;
  },
};

export const PHONE_INPUT_LOAD_UTILS = (): Promise<{ default: ItiUtils }> =>
  import('intl-tel-input/dist/js/utils.js') as Promise<{ default: ItiUtils }>;
